module.exports = __webpack_public_path__ + "img/qrpay_logo_h.3de70112.png";